package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.KeyboardArrowDownW500Rounded: ImageVector
    get() {
        if (_keyboardArrowDownW500Rounded != null) {
            return _keyboardArrowDownW500Rounded!!
        }
        _keyboardArrowDownW500Rounded = Builder(name = "KeyboardArrowDownW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(462.85f, 601.4f)
                quadToRelative(-8.2f, -3.1f, -14.92f, -9.81f)
                lineTo(264.17f, 407.83f)
                quadTo(251.5f, 395.15f, 251.5f, 376.0f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                quadTo(276.85f, 331.5f, 296.0f, 331.5f)
                reflectiveQuadToRelative(31.83f, 12.67f)
                lineTo(480.0f, 496.35f)
                lineToRelative(152.17f, -152.18f)
                quadTo(644.85f, 331.5f, 664.0f, 331.5f)
                reflectiveQuadToRelative(31.83f, 12.67f)
                quadTo(708.5f, 356.85f, 708.5f, 376.0f)
                reflectiveQuadToRelative(-12.67f, 31.83f)
                lineTo(512.07f, 591.59f)
                quadToRelative(-6.72f, 6.71f, -14.92f, 9.81f)
                quadToRelative(-8.19f, 3.1f, -17.15f, 3.1f)
                quadToRelative(-8.96f, 0.0f, -17.15f, -3.1f)
                close()
            }
        }
        .build()
        return _keyboardArrowDownW500Rounded!!
    }

private var _keyboardArrowDownW500Rounded: ImageVector? = null
